import FacebookIcon from './Facebook';
import GoogleIcon from './Google';
import Logo from './Logo';
import LogoIcon from './LogoIcon';
import MicrosoftIcon from './Microsoft';

export { FacebookIcon, GoogleIcon, Logo, LogoIcon, MicrosoftIcon };
